export default __webpack_public_path__ + "static/media/dimension.aec85b81.svg";